import React from 'react'
import View from './view.js'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import useListItemDataOnChange from './useListItemDataOnChange.js'

export default function Logic(props) {
  let change = useDataChange({
    context: 'automation',
    viewPath: props.viewPath,
    path: 'actions',
  })
  let actions = useDataValue({
    context: 'automation',
    path: 'actions',
    viewPath: props.viewPath,
  })

  function onDragEnd(result) {
    if (!result.destination) {
      return
    }

    // If the item was dropped in the same position, do nothing
    if (result.destination.index === result.source.index) {
      return
    }

    // Reorder the items array
    let newItems = Array.from(actions)
    let [reorderedItem] = newItems.splice(result.source.index, 1)
    newItems.splice(result.destination.index, 0, reorderedItem)

    newItems = newItems.map((item, index) => ({
      ...item,
      order: index,
    }))

    change(newItems)
  }
  return (
    <View
      {...props}
      onDragEnd={onDragEnd}
      useListItemDataOnChange={useListItemDataOnChange}
    />
  )
}
